export const PASCAL_PLATFORM_ID = 72; // 18746949;
